{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "További képek hozzáadása"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Jóváhagyás"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Vissza"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Vissza a bejelentkezéshez"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Rendelés hozzáadása a szobaszámlához"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Tovább vásárolok"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Mégsem"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Bezárás"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Vásárlás befejezése"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Tovább"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Hitel- vagy bankkártya"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "KÉSZ"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Letöltés"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Rendelés szerkesztése"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Belépés"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Elfelejtettem"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Megvan."
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Következő(jobbra mutató nyíl)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Előző(balra mutató nyíl)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Nagyítás/kicsinyítés"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Kijelentkezés"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Bejelentkezés"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Keresés a galériában"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "További képek"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Új rendelés"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "Rendben"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Útmutató az árakhoz"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Nyomtatás"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Feldolgozás"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Vásárlás"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Frissítés"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Eltávolítás"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Nyomtatott képek eltávolítása"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Áttekintés és vásárlás"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Kiválasztás"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Kiválasztott nyomtatási méretek ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Link küldése"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Hivatkozások küldése"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Megosztás"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Bejelentkezve maradok"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Stripe"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Galéria megtekintése"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Galériám megtekintése"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Nyugta megtekintése"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Ingyenesen adhatsz hozzá további képeket"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Alkalmazás"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Az összes kép ára: "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Vásárold meg az összes képet "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " áron!"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 0,
      "value": "Az összes kép ára: "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Kosár tartalma"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Kosár összege"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Fizetés"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Kuponkód"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Hitel- vagy bankkártya"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Digitális kép(ek)"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitális kép"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitális kép"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitális kép"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitális kép"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " nyomat"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " nyomat"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Vásárolj több képet, és kedvezményt adunk!"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Ezt a képet ajándékba adjuk: "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "A galériád linkjét elküldtük a következő címre: "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Fizetés előtt válaszd ki a megvásárolni kívánt képeket!"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "Dátum: "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " kép"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " kép"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " megvásárlása "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " áron"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Szerezd meg az összes képet "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " áron!"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Szerezz meg "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " képet "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " áron"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " áron"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " áron"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Útmutató az árakhoz"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Az árazásért lásd az Árútmutatót"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " nyomat"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " nyomat"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Vásárlás"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Megvásárolt tételek"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Vásárlás folyamatban"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Sajnáljuk, hiba történt, amely megakadályozta a terhelés végrehajtását. Kérjük, próbálkozz újra, és lépj kapcsolatba velünk, ha a probléma továbbra is fennáll."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "A normál ár tételenként: "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Köszönjük a vásárlást!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Összesen"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Összes digitális kép"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Összes digitális és nyomtatott kép"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Meg nem vásárolt tételek"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Fotók megtekintése"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Vásároljon "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " képet"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " képet"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ", és kapjon "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " kedvezményt"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " kedvezmény "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " vagy több tétel esetén"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "A Capturelife használatával elfogadod a(z)"
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Írd be és erősítsd meg a jelszavad."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Jelszó megerősítése"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Kapcsolatfelvétel"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "E-mail-cím vagy telefonszám"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "E-mail-cím vagy telefonszám"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mail-cím"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Kérjük, adj meg egy e-mail címet."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Adj meg egy jelszót."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Kérjük, adj meg egy érvényes e-mail-címet vagy telefonszámot."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "A VARÁZSLÓVILÁG-ot és minden kapcsolódó védjegyet, karaktert, nevet és jelzést szerzői jog véd, és a Warner Bros. Entertainment Inc. bejegyzett tulajdona Kiadói jogok © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "A jelszavad visszaállításához add meg e-mail-címedet vagy telefonszámodat"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Elfelejtetted a jelszavad?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Nyomtatott képek boltja"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "QR-kód generálása"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Ez a link sajnos lejárt. Add meg az e-mail címed vagy telefonszámod, hogy új linket küldhessünk."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Bejelentkezés..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Térjünk vissza ezeknek a pillanatoknak a megörökítéséhez!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Úgy tűnik, kihagytál valamit."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Személyes adataim"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Fotók hozzáadása"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Hozzáadás"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Vissza"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Letöltés"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Kezdőoldal"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Kijelentkezés"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Hírek"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Nyomtatott képek boltja"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Frissítés"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Megosztás"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "A jelszónak legalább "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " karakterből kell állnia."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Jelszó"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "A jelszavak nem egyeznek."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Készíts képernyőképet a QR-kódról, vagy kattints az alatta található Letöltés gombra"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Jelszó visszaállítása"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Jelszó visszaállítása..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Összes kiválasztása"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "A képek letöltéséhez vagy megosztásához koppints hosszan a képre, hogy megjelenjenek az eszköz megosztási lehetőségei."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Online áruház"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Felhasználási feltételek"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Kérjük, add meg a használni kívánt e-mail-címet és jelszót."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Jelszó frissítése"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Jelszó frissítése"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Jelszó frissítése..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Üdv újra itt!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Kedvezménykód nem alkalmazható. A vásárlás összege kisebb a szükséges minimális összegnél"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Kedvezménykód nem található"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Kérjük, adj meg egy valós e-mail-címet."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Kérjük, add meg az e-mail-címed."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Kérjük, töltsd ki az alábbi mezőket!"
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Foglalás nem található."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Ehhez a fiókhoz nem tartoznak fotók. Kérjük, olvasd be a fotóállomáson használt csuklópántot"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Ehhez a fiókhoz nem tartoznak fotók. Kérjük, keress fel egy fotóst vagy segítőt"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Hitel- vagy bankkártya"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mail-cím"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "E-mail-cím"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Vezetéknév"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Jelszó"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "PIN-kód"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Ár ("
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": " pénznemben)"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Szobaszám"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Titkos kód"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Összes kiválasztása"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Minden kép feloldása"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Jóváhagyás szükséges"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "A jóváhagyáshoz kérd kollégáink segítségét!"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Vásárlás jóváhagyása"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Add meg a vásárlás árát."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " másodperc"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " másodperc"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " múlva automatikusan kijelentkezik"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Hahó, itt vagy még?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitális kép"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitális kép"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " nyomat"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " nyomat"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Áttekintés és vásárlás"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Koppints a "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " elemre, ha el szeretnél távolítani egy képet a kosaradból. A folytatáshoz koppints a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "VÁSÁRLÁS BEFEJEZÉSE"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " elemre."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Képek hozzáadása a galériádhoz"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Megvásárolni kívánt képek kiválasztása"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Koppints a képekre, hogy hozzáadd őket a galériádhoz. Koppints a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "GALÉRIÁM MEGTEKINTÉSE"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " elemre, ha vissza szeretnél térni a galériádba."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Koppints a képekre, hogy hozzáadhasd őket rendelésedhez. A folytatáshoz koppints az "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ÁTTEKINTÉS ÉS VÁSÁRLÁS"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " lehetőségre."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Képek betöltése..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Kiválasztás és vásárlás"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "A Te galériád"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Kiválasztás és nyomtatás"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "A Te galériád"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Koppints a megvásárolni kívánt képre. Koppints erre: "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " a folytatáshoz."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "A galériád üres. Koppints a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "TOVÁBBI KÉPEK"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " elemre a képernyő jobb felső sarkában az elérhető képek böngészéséhez."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "A képen látható Nyomtatás ikonra koppintva kiválaszthatod azt nyomtatásra. Koppints a Nyomtatás gombra a kiválasztott képek letöltéséhez"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Koppints a megvásárolni kívánt képre. Nyomtatás kéréséhez koppints duplán. Koppints erre: "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " a folytatáshoz."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Feloldottad az összes kép zárolását. Koppints ide "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": ", ha el szeretnéd távolítani a galériádból."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Feloldottad az összes kép zárolását. Nyomtatási kérelemhez koppints egy képre. Koppints ide "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": ", ha el szeretnéd távolítani a galériádból."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Nyomtatott kép hozzáadása"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digitálisan megvásárolt"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Megvásárolt nyomtatott kép"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Nyomtatott kép kiválasztva"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Nyomtatott kép eltávolítása"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Nyomtatott kép kiválasztása"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "A Te képeid"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Képek kiválasztása"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "A Te választásaid"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Hozzáférés a képekhez"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Add meg a szobaszámod, a vezetékneved és az e-mail-címed a galériádhoz való hozzáféréshez"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Üdvözlünk!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "A VARÁZSLÓVILÁG-ot és minden kapcsolódó védjegyet, karaktert, nevet és jelzést szerzői jog véd, és a Warner Bros. Entertainment Inc. bejegyzett tulajdona Kiadói jogok © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Kérjük, add meg e-mail-címed a folytatáshoz."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Szkenneld be a csuklópántot a kezdéshez"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Rendelés hozzáadása a szobaszámlához"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Az alábbi összeget a szobaszámládhoz adjuk"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Vásárlás befejezése"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Rendelésed tartalma:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Minden értékesítés végleges, és visszatérítésre nincs lehetőség."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Rendelés részletei"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Koppints a bal oldalon található képekre a kiválasztáshoz és a vásárláshoz."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "A kosarad üres. Koppints a képekre, hogy hozzáadhasd őket a rendelésedhez."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "A kosarad üres. További képek hozzáadásához koppints a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "TOVÁBBI KÉPEK HOZZÁADÁSA"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " elemre"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "A képeket e-mailben fogod megkapni"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Nyomtatás kéréséhez koppints duplán a képre."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Vásárlás befejezése"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Hogyan szeretnéd befejezni a vásárlást?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Útmutató az árakhoz"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Vásárolj több képet, és kedvezményt adunk!"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "A normál ár "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " képenként"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Ingyenesen adhatsz hozzá további képeket"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Nyomtatási méretek"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Válaszd ki a nyomtatási méret(eke)t és a darabszámot"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Fizetés feldolgozása folyamatban..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Kínált kedvezmények:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Kínált csomagok:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " képenként"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Normál ár:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Összesen:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Koppints a képekre, hogy hozzáadhasd őket a rendelésedhez"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Koppints a képekre, hogy kiválaszd őket vagy töröld a kiválasztásukat a vásárláshoz. Ha további képeket szeretnél hozzáadni a kiválasztott termékekhez, koppints a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "TOVÁBBI KÉPEK"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " elemre."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Az olvasó nincs csatlakoztatva"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Az olvasó nem tudta feldolgozni"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Olvasó készenléti állapotban..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "A vásárlás befejeződött"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "A galériád linkjét elküldtük a következő címre: "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Szeretnéd eltávolítani ezt a képet a rendelésedből? Keresd meg újra a képet a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "TOVÁBBI KÉPEK HOZZÁADÁSA"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " elemre koppintva."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Szoba "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Szobák "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Egy hivatkozást e-mailben elküldtünk a következő címre: "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Képarány"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Kiválasztott nyomtatott képek"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Pillanat"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Darabszám"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Nyomtatási méret"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Vásárlás befejezése"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Fizetési adatok megadása"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Üdv, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Üdv, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}